import { lazy } from 'react';
import { Loader } from '@client/components/common/Loader';
import { Modal } from '../../globals/Modal';
import type { LoginModalProps } from '../common/LoginModalProps.interface';

const SignupLoader = lazy(() => import('./Signup'));

export const openSignupModal = (props?: LoginModalProps) => Modal.show({
  body: (
    <Loader
      load={SignupLoader}
      {...props}
    />
  ),
  buttons: [],
});
